// Polyfills must load first for IE11 compatibility
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import { createRoot } from 'react-dom/client'
import '../style.css'
import { FeatureFlagsProvider } from '@/lib/feature-flags'
import { SnapshotsEnabledProvider } from '@/lib/hooks/use-snapshots-enabled'
import { PlatformProvider } from '@/lib/platform'
import App from './components/App'

const rootElement: HTMLElement | null = document.getElementById('container')
const root = rootElement ? createRoot(rootElement) : undefined

/* Render application after Office initializes */
Office.onReady(() => {
  root?.render(
    <PlatformProvider platform="excel">
      <FeatureFlagsProvider>
        <SnapshotsEnabledProvider>
          <App />
        </SnapshotsEnabledProvider>
      </FeatureFlagsProvider>
    </PlatformProvider>
  )
})
